import { withTranslation } from "react-i18next";

import React from 'react';
import { Footer, Header } from '../Common';
import Products from '../../Models/Products';
import { connect } from 'react-redux';
import { paymentMethod } from '../../Action/paymentMehod';
import { withRouter } from 'react-router-dom';
import Cookies from 'universal-cookie';
import Affiliator from '../../Models/Affiliator';
import Request from '../../Models/Request';
import Modal from 'react-modal';
import stripHtml from "string-strip-html";
import SimpleReactValidator from 'simple-react-validator';
import {Spinner } from 'reactstrap';
import Common from "../../Models/Common";
import axios from "axios";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        marginTop: '50px',
        transform: 'translate(-50%, -50%)',
        // backgroundColor:'#ccc'
    },
    overlay: {
        backgroundColor: '#CCC'
    },

};

class Purchase extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: false,
            modalRequestopenpoints: false,
            modalRequestopencredit: false,
            modalRequestopenbank: false,
            modalIsOpenwithpoint: false,
            modalIsOpenbank: false,
            modalIsOpenbankinstructions: false,
            modalIsOpenbankinstructionsrequest: false,
            modalIsOpen: false,
            modalIsOpenCredit: false,
            creditcardnumber: '',
            validity: '',
            security: '',
            name: '',
            productDetails: [],
            productDetails_single: [],
            request: [],
            response: [],
            serviceId: '',
            sellerId: '',
            seller_single: [],
            seller_request: [],
            creditCard: '',
            mobileCarrier: '',
            convientPayment: '',
            bitCash: '',
            bankTransfer: '',
            selectedOption: '',
            aff_Id: '',
            cookiesAll: '',
            buyer_id: localStorage.getItem('info.id'),
            product_description: '',
            product_name: '',
            av_points: '',
            siteid: '20236601',
            sitepass: '6601wuro',
            renewal_type: 1,
            extra_text: '',
            ready: 0,
            special: 1
        };
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
        console.log(this.props)
        var x = parseInt(this.props.match.params.id, 16)
        var id = (x - 521)
        console.log(id)
        if(this.props.location.state.id > 0){
            this.setState({ ready: 0 })
            this.getId(this.props.location.state.id);
        }
        this.getDetails(this.props.location.state.id);
        this.getDetailsRequest(this.props.location.state.request_id, this.props.location.state.seller_id);
        // this.getDetailsRequest(16, 37);
        this.getCookies();
        // var buyer_id = JSON.parse(localStorage.getItem('info'))
        this.postProduct = this.postProduct.bind(this);
        this.postRequestPurchase = this.postRequestPurchase.bind(this);

        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

        this.openModalforcreditcard = this.openModalforcreditcard.bind(this);
        this.afterOpenModalforcreditcard = this.afterOpenModalforcreditcard.bind(this);
        this.closeModalforcreditcard = this.closeModalforcreditcard.bind(this);
        this.creditsubmit = this.creditsubmit.bind(this);

        this.openModalwithpoint = this.openModalwithpoint.bind(this);
        this.afteropenModalwithpoint = this.afteropenModalwithpoint.bind(this);
        this.closeModalwithpoint = this.closeModalwithpoint.bind(this);

        this.openModalforbank = this.openModalforbank.bind(this);
        this.afteropenModalforbank = this.afteropenModalforbank.bind(this);
        this.closeModalforbank = this.closeModalforbank.bind(this);

        this.openModalforbankinstructions = this.openModalforbankinstructions.bind(this);
        this.afteropenModalforbankinstructions = this.afteropenModalforbankinstructions.bind(this);
        this.closeModalforbankinstructions = this.closeModalforbankinstructions.bind(this);

        this.instructionreceived = this.instructionreceived.bind(this);

        this.openModalwithpointrequest = this.openModalwithpointrequest.bind(this);
        this.afteropenModalwithpointrequest = this.afteropenModalwithpointrequest.bind(this);
        this.closeModalwithpointrequest = this.closeModalwithpointrequest.bind(this);

        this.openModalwithbankrequest = this.openModalwithbankrequest.bind(this);
        this.afteropenModalwithbankrequest = this.afteropenModalwithbankrequest.bind(this);
        this.closeModalwithbankrequest = this.closeModalwithbankrequest.bind(this);

        this.openModalwithpointrequest = this.openModalwithpointrequest.bind(this);
        this.afteropenModalwithpointrequest = this.afteropenModalwithpointrequest.bind(this);
        this.closeModalwithpointrequest = this.closeModalwithpointrequest.bind(this);

        this.openModalwithcreditrequest = this.openModalwithcreditrequest.bind(this);
        this.afteropenModalwithcreditrequest = this.afteropenModalwithcreditrequest.bind(this);
        this.closeModalwithcreditrequest = this.closeModalwithcreditrequest.bind(this);
        // this.postData = this.postData.bind(this);
    }

    componentDidMount() {
        const min = 100;
        const max = 1000000;
        const rand = min + Math.random() * (max - min);
        this.setState({ special: Math.floor(rand) });
        setTimeout(
            function() {
                this.setState({ready: 1});
            }
            .bind(this),
            1000
        );
        console.log(this.props.location.state);
        var buyer_id = JSON.parse(localStorage.getItem('info'))
        this.state.buyer_id = buyer_id.id;
        Request.getMyPoints(buyer_id.id).then(res => {
            this.setState({ av_points: res.data.points })
        })

        window.scrollTo(0, 0)
    }

    getDetails(id) {
        Products.getProductsDetails(id).then(res => {
            this.setState({ productDetails: res.data.product })
            this.setState({ productDetails_single: res.data.product_single })
            this.setState({ seller_single: res.data.seller_single })
            this.setState({ product_description: stripHtml(res.data.product_single.trimed_long_desc) })
        })
    }

    getDetailsRequest(id, seller) {
        Products.getRequestDetails(id, seller).then(res => {
            this.setState({ request: res.data.request })
            this.setState({ seller_request: res.data.seller })
            this.setState({ response: res.data.response })
            this.setState({ product_name: res.data.product_name })
            // this.setState({ product_description: stripHtml(res.data.product_single.trimed_long_desc) })
        })
    }

    getCookies() {
        let x = JSON.parse(localStorage.getItem('info'))
        Affiliator.getAffiliatorInfo(x.id, this.props.location.state.id).then(res => {
            this.setState({ aff_Id: res.data.affiliator })
        })
        console.log(this.state.aff_Id)
    }

    getId(id) {
        Products.getProductsDetails(id).then(res => {
            this.setState({
                serviceId: res.data.product_single.service_id,
                productId: res.data.product_single.id,
                ready: 1
            })
            if(res.data.product_single.renewal_type === 1){
                this.setState({
                    siteid: '20236601',
                    sitepass: '6601wuro'
                })
            } else {
                this.setState({
                    siteid: '20236602',
                    sitepass: '6602wuro',
                    renewal_type: 2,
                    extra_text: ` (${this.props.t('92')})`
                })
            }
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            this.setState({ errors: nextProps.errors })
        }
    }

    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }
    //Main product purchase modal
    openModal() {
        this.setState({ modalIsOpen: true });
    }

    afterOpenModal() {
        console.log("after open modal");
    }

    closeModal(e) {
        e.preventDefault();
        this.setState({ modalIsOpen: false });
        this.setState({ modalIsOpenCredit: true });
    }

    //Credit card info modal
    openModalforcreditcard() {
        this.setState({ modalIsOpenCredit: true });
    }

    afterOpenModalforcreditcard() {
        console.log("after open modal");
    }

    closeModalforcreditcard(e) {
        e.preventDefault();
        this.setState({ security: '' });
        this.setState({ creditcardnumber: '' });
        this.setState({ validity: '' });
        this.setState({ name: '' });
        this.setState({ modalIsOpenCredit: false });
    }

    creditsubmit(e) {
        e.preventDefault();
        if (this.state.security === '' || this.state.creditcardnumber === '' || this.state.validity === '' || this.state.name === '') {
            alert(this.props.t('15'))
        } else {
            this.setState({ modalIsOpenCredit: false });
            if (this.props.location.state.flag === 'product') {
                this.openModal();
            } else {
                this.openModalwithcreditrequest()
            }
        }
    }

    //Main product purchase modal for payment with point
    openModalwithpoint() {
        this.setState({ modalIsOpenwithpoint: true });
    }

    afteropenModalwithpoint() {
        console.log("after open modal");
    }

    closeModalwithpoint() {
        this.setState({ modalIsOpenwithpoint: false });
    }

    //Main product purchase modal for bank payment
    openModalforbank() {
        this.setState({ modalIsOpenbank: true });
    }

    afteropenModalforbank() {
        console.log("after open modal");
    }

    closeModalforbank() {
        this.setState({ modalIsOpenbank: false });
    }

    //Bank payment instructions
    openModalforbankinstructions() {
        this.setState({ modalIsOpenbankinstructions: true });
    }

    afteropenModalforbankinstructions() {
        console.log("after open modal");
    }

    closeModalforbankinstructions() {
        this.setState({ modalIsOpenbankinstructions: false });
    }

    //Bank payment instructions for requests
    openModalforbankinstructionsrequest() {
        this.setState({ modalIsOpenbankinstructionsrequest: true });
    }

    afteropenModalforbankinstructionsrequest() {
        console.log("after open modal");
    }

    closeModalforbankinstructionsrequest() {
        this.setState({ modalIsOpenbankinstructionsrequest: false });
    }

    instructionreceived() {
        this.closeModalforbankinstructions();
        if (this.props.location.state.flag === 'product') {
            this.openModalforbank();
        } else {
            this.openModalwithbankrequest();
        }

    }

    //Request payment bank
    openModalwithbankrequest() {
        this.setState({ modalRequestopenbank: true });
    }

    afteropenModalwithbankrequest() {
        console.log("after open modal");
    }

    closeModalwithbankrequest() {
        this.setState({ modalRequestopenbank: false });
    }

    //Request payment creadit card
    openModalwithcreditrequest() {
        this.setState({ modalRequestopencredit: true });
    }

    afteropenModalwithcreditrequest() {
        console.log("after open modal");
    }

    closeModalwithcreditrequest(e) {
        e.preventDefault();
        this.setState({ modalRequestopencredit: false });
        this.setState({ modalIsOpenCredit: true });
    }

    //Request payment points
    openModalwithpointrequest() {
        this.setState({ modalRequestopenpoints: true });
    }

    afteropenModalwithpointrequest() {
        console.log("after open modal");
    }

    closeModalwithpointrequest() {
        this.setState({ modalRequestopenpoints: false });
    }


    postProduct(e) {
        e.preventDefault();
        let x = JSON.parse(localStorage.getItem('info'))
        let userId = x.user_type_id
        let affId = JSON.parse(localStorage.getItem('aff-id'))
        if (affId > 0) {
            let data = {
                service_id: this.state.serviceId,
                product_id: this.state.productId,
                buyer_id: this.state.buyer_id,
                aff_id: affId,
                content: this.state.productDetails_single.short_desc,
                payment_method_id: this.state.selectedOption,
                flag: 'product'

            }
            this.props.paymentMethod(userId, data, this.props.history);
        } else {
            let data = {
                service_id: this.state.serviceId,
                product_id: this.state.productId,
                buyer_id: this.state.buyer_id,
                aff_id: this.state.aff_Id,
                content: this.state.productDetails_single.short_desc,
                payment_method_id: this.state.selectedOption,
                flag: 'product'

            }
            this.props.paymentMethod(userId, data, this.props.history);
        }
    }

    postRequestPurchase(e) {
        e.preventDefault()
        let x = JSON.parse(localStorage.getItem('info'))
        let userId = x.user_type_id
        let data_acc = {
            'request_id': this.props.location.state.request_id,
            'seller_id': this.props.location.state.seller_id,
            'buyer_id': this.props.location.state.buyer_id,
            'estimated_price': this.props.location.state.estimated_price,
            'estimated_deadline': this.props.location.state.estimated_deadline
        }
        console.log(data_acc)
        // Request.acceptResponse(data_acc).then(res => {
        //     if (res.data.status === 200) {
        //         alert('You have accepted and paid this response successfully!')
        //     } else if (res.data.status === 10060) {
        //         alert('You have already accepted another proposal!');
        //         return;
        //     } else {
        //         alert('Your response cannot be processed now. sorry!');
        //         return;
        //     }
        // })
        let data = {
            buyer_id: x.id,
            request_id: this.props.location.state.request_id,
            seller_id: this.props.location.state.seller_id,
            estimated_price: this.props.location.state.estimated_price,
            estimated_deadline: this.props.location.state.estimated_deadline,
            payment_method_id: this.state.selectedOption,
            flag: ''
        }
        console.log(data)
        this.props.paymentMethod(userId, data, this.props.history);
    }

    handlePurchaseSubmit(e){
        e.preventDefault()
        // console.log("$$$$$$ card payment submit");
        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());
        // console.log("$$$$$$$$$$$$$ data:::::::: ", data);
        axios.post(Common.api + 'purchase', data).then( res =>{
            // console.log("resssssssssssssssssssssssssssssss url>>", res?.data?.url);
            this.props.history.push(res?.data?.url);
        })
    }

    handleSubmit(e) {
        e.preventDefault()
        var buyer_id = JSON.parse(localStorage.getItem('info'))
        this.setState({ buyer_id: buyer_id.id })
        // alert(buyer_id.id);
        // console.log("state::", this.props.location.state);
        if (this.props.location.state.flag === 'product') {
            // console.log(":: selected option:: ", this.state.selectedOption)
            if (this.state.selectedOption === '1') {
                // console.log("::::: 1 selected");
                this.openModalforcreditcard();
            } else if (this.state.selectedOption === '3') {
                // console.log("::::: 3 selected");
                if (this.props.location.state.estimated_price == undefined) {
                    var p = this.state.productDetails_single.price;
                } else {
                    var p = this.props.location.state.estimated_price;
                }

                if (this.state.av_points < p) {
                    alert(this.props.t('14'));
                } else {
                    this.openModalwithpoint();
                }
            } else if (this.state.selectedOption === '2') {
                // console.log("::::: 2 selected");
                this.openModalforbankinstructions();
            } else {
                alert("something wrong");
            }
            // this.openModal();
        } else {
            // console.log("err: selected option: ", this.state.selectedOption);
            if (this.state.selectedOption === '1') {
                this.openModalforcreditcard();
            } else if (this.state.selectedOption === '3') {
                this.openModalwithpointrequest();
            } else if (this.state.selectedOption === '2') {
                this.openModalforbankinstructions();
            } else {
                alert("something wrong");
            }
        }

        // console.log(data)


    }

    radioChange(e) {
        this.setState({
            selectedOption: e.target.value
        });
        console.log(e.target.value);
        if(e.target.value === '3'){
            document.getElementById('using_point').style.display = "block";
            document.getElementById('using_bank').style.display = "none";
            document.getElementById('using_card').style.display = "none";
        } else if(e.target.value === '1'){
            document.getElementById('using_point').style.display = "none";
            document.getElementById('using_card').style.display = "block";
            document.getElementById('using_bank').style.display = "none";
        } else if(e.target.value === '2'){
            document.getElementById('using_point').style.display = "none";
            document.getElementById('using_card').style.display = "none";
            document.getElementById('using_bank').style.display = "block";
        }
    }

    paymentMehod() {
        var x = JSON.parse(localStorage.getItem('info'))
        if (this.state.renewal_type == 2) {
            return (
                <div className="" style={{ fontSize: '11px' }}>
                    <div className="radio select_method">
                        <label><input type="radio" name="optradio" className="mr-4" value="1" checked={this.state.selectedOption === '1'} onChange={this.radioChange.bind(this)} /><b>{this.props.t('22')}</b></label>&nbsp;<span><img src={require("../../assets/images/gates-renewable.png")} width="180" height="40" alt="" /></span>
                    </div>
                </div>
            )
        } else if(x.user_type_id === 1) {
            return (
                <div className="" style={{ fontSize: '11px' }}>
                    <div className="radio select_method">
                        <label><input type="radio" name="optradio" className="mr-4" value="1" checked={this.state.selectedOption === '1'} onChange={this.radioChange.bind(this)} /><b>{this.props.t('22')}</b></label>&nbsp;<span><img src={require("../../assets/images/gates.png")} width="180" height="45" alt="" /></span>
                    </div>
                    <div className="radio select_method">
                        <label><input type="radio" name="optradio" className="mr-4" value="2" checked={this.state.selectedOption === '2'} onChange={this.radioChange.bind(this)} /><b>{this.props.t('93')}</b></label>&nbsp;<span></span>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="" style={{ fontSize: '11px' }}>
                    <div className="radio select_method">
                        <label><input type="radio" name="optradio" className="mr-4" value="3" checked={this.state.selectedOption === '3'} onChange={this.radioChange.bind(this)} /><b>{this.props.t('29')}</b></label>
                    </div>
                    <div className="radio select_method">
                        <label><input type="radio" name="optradio" className="mr-4" value="1" checked={this.state.selectedOption === '1'} onChange={this.radioChange.bind(this)} /><b>{this.props.t('22')}</b></label>&nbsp;<span><img src={require("../../assets/images/gates.png")} width="180" height="auto" alt="" /></span>
                    </div>
                    <div className="radio select_method">
                        <label><input type="radio" name="optradio" className="mr-4" value="2" checked={this.state.selectedOption === '2'} onChange={this.radioChange.bind(this)} /><b>{this.props.t('93')}</b></label>&nbsp;<span></span>
                    </div>
                </div>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (this.state.ready === 1) {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        if (isMobile) {
            return (
                <div className="wrapper">
                    <Header />

                    {/* Confirmation modal */}

                    {/* Credit card input modal */}
                    <div>
                        <Modal
                            isOpen={this.state.modalIsOpenCredit}
                            onAfterOpen={this.afterOpenModalforcreditcard}
                            onRequestClose={this.closeModalforcreditcard}
                            style={customStyles}
                            // overlayClassName="Overlay"
                            contentLabel="Example Modal"
                        >

                            <div style={{ width: "270px", height: "400px", overflow: "auto" }}>
                                <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModalforcreditcard} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div style={{ padding: "1%" }}>
                                    <form>
                                        {/* <fieldset style={{ border: "1px solid #008dc7", paddingLeft: "4%", paddingRight: "4%", paddingBottom: "4%" }}> */}
                                        <legend style={{ width: "0%", color: "#008dc7", fontSize: "20px" }}></legend>
                                        <div><br /></div>
                                        <div className="col-md-12">
                                            <div className="col-md-4" style={{ paddingTop: "2%", textAlign: "left" }}>
                                                <span>{this.props.t('38')}</span>
                                            </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-7">
                                                <div>
                                                    <input
                                                        style={{ padding: "2%", border: "1px solid #d8e6e8" }}
                                                        type="text"
                                                        className="catagory_select"
                                                        id="name"
                                                        value={this.state.name}
                                                        onChange={this.updateValue.bind(this, 'name')}
                                                    />
                                                </div>
                                                <div>
                                                    <span style={{ color: "grey", fontSize: "12px" }}>※{this.props.t('6')}</span>
                                                </div>

                                            </div>
                                        </div>
                                        <div><br /></div>
                                        <div className="col-md-12">
                                            <div className="col-md-4" style={{ paddingTop: "2%", textAlign: "left" }}>
                                                <span>{this.props.t('64')}</span>
                                            </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-7">
                                                <div>
                                                    <input
                                                        style={{ padding: "2%", border: "1px solid #d8e6e8" }}
                                                        type="number"
                                                        className="catagory_select"
                                                        id="creditcardnumber"
                                                        value={this.state.creditcardnumber}
                                                        onChange={this.updateValue.bind(this, 'creditcardnumber')}
                                                    />
                                                </div>
                                                <div>
                                                    <span style={{ color: "grey", fontSize: "12px" }}>{this.props.t('179')}1234567890123456</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div><br /></div>
                                        <div className="col-md-12">
                                            <div className="col-md-4" style={{ paddingTop: "2%", textAlign: "left" }}>
                                                <span>{this.props.t('95')}</span>
                                            </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-7">
                                                <div>
                                                    <input
                                                        style={{ padding: "1%", border: "1px solid #d8e6e8" }}
                                                        type="date"
                                                        className="validity"
                                                        id="title"
                                                        value={this.state.validity}
                                                        onChange={this.updateValue.bind(this, 'validity')}
                                                    />
                                                </div>
                                                <div>
                                                    <span style={{ color: "grey", fontSize: "12px" }}>※{this.props.t('7')}</span>
                                                </div>

                                            </div>
                                        </div>
                                        <div><br /></div>
                                        <div className=" col-md-12">
                                            <div className="col-md-4" style={{ paddingTop: "1%", textAlign: "left" }}>
                                                <span>{this.props.t('16')}</span>
                                            </div>
                                            <div className="col-md-1"></div>
                                            <div className="col-md-7">
                                                <input
                                                    style={{ padding: "2%", border: "1px solid #d8e6e8" }}
                                                    type="number"
                                                    className="catagory_select"
                                                    id="security"
                                                    value={this.state.security}
                                                    onChange={this.updateValue.bind(this, 'security')}
                                                />
                                            </div>
                                        </div>
                                        {/* </fieldset> */}


                                        <div>&nbsp;</div>
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModalforcreditcard} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>{this.props.t('65')}</button>&nbsp;
                                        <button onClick={this.creditsubmit} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>{this.props.t('96')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>

                    {/* ProductConfirmation modal */}
                    <div>
                        <Modal
                            isOpen={this.state.modalIsOpen}
                            onAfterOpen={this.afterOpenModal}
                            onRequestClose={this.closeModal}
                            style={customStyles}
                            contentLabel="Example Modal"
                        >
                            <div style={{ width: "270px", height: "400px", overflow: "auto" }}>
                                <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModal} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div className="pages_contents" style={{ padding: "1%" }}>
                                    <form>

                                        <legend style={{ width: "100%", paddingLeft: '5%', fontSize: "20px" }}>{this.props.t('39')}</legend>
                                        <div className="col-md-12"><br /></div>
                                        <div className="mb-2">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><b>{this.props.t('66')} :</b></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.productDetails_single.title}</span>
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><b>{this.props.t('67')} :</b></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.productDetails_single.category_main}</span>
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><b>{this.props.t('68')} :</b></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.productDetails_single.category_sub}</span>
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><b>{this.props.t('40')} :</b></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                {/* <span>{this.state.productDetails_single.long_desc}</span> */}
                                                <span>{this.state.product_description}....</span>
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><b>{this.props.t('180')} :</b></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.productDetails_single.price} {this.props.t('199')}</span>
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><b>{this.props.t('97')} :</b></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.productDetails_single.delivery_format}</span>
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><b>{this.props.t('30')} :</b></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.productDetails_single.expected_delivery_days}</span>
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><b>{this.props.t('167')} :</b></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.seller_single.first_name}</span>
                                            </div>
                                        </div>


                                        <div><br /></div>

                                        <legend style={{ width: "100%", paddingLeft: '5%', fontSize: "20px" }}>{this.props.t('25')}</legend>
                                        <div className="mb-2">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><b>{this.props.t('64')} :</b></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.creditcardnumber}</span>
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><b>{this.props.t('95')} :</b></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.validity}</span>
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><b>{this.props.t('38')} :</b></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.name}</span>
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><b>{this.props.t('16')} :</b></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.security}</span>
                                            </div>
                                        </div>



                                        <div>&nbsp;</div>
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModal} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>{this.props.t('99')}</button>&nbsp;
                                        <button onClick={this.postProduct} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>{this.props.t('100')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>
                    {/* confirmation modal ends */}

                    {/* Confirmation modal for payment with point */}
                    <div>
                        <Modal
                            isOpen={this.state.modalIsOpenwithpoint}
                            onAfterOpen={this.afteropenModalwithpoint}
                            onRequestClose={this.closeModalwithpoint}
                            style={customStyles}
                            contentLabel="Example Modal"
                        >
                            <div style={{ width: "270px", height: "400px", overflow: "auto" }}>
                                <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModalwithpoint} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div className="pages_contents" style={{ padding: "1%" }}>
                                    <form>

                                        <legend style={{ width: "100%", paddingLeft: '5%', fontSize: "20px" }}>{this.props.t('39')}</legend>
                                        <div className="col-md-12"><br /></div>
                                        <div className="mb-2">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><b>{this.props.t('66')} :</b></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.productDetails_single.title}</span>
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><b>{this.props.t('67')} :</b></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.productDetails_single.category_main}</span>
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><b>{this.props.t('68')} :</b></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.productDetails_single.category_sub}</span>
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><b>{this.props.t('40')} :</b></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                {/* <span>{this.state.productDetails_single.long_desc}</span> */}
                                                <span>{this.state.product_description}....</span>
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><b>{this.props.t('180')} :</b></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.productDetails_single.price} {this.props.t('199')}</span>
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><b>{this.props.t('97')} :</b></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.productDetails_single.delivery_format}</span>
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><b>{this.props.t('30')} :</b></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.productDetails_single.expected_delivery_days}</span>
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><b>{this.props.t('167')} :</b></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.seller_single.first_name}</span>
                                            </div>
                                        </div>
                                        <div><br /></div>
                                        <div>&nbsp;</div>
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModalwithpoint} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>{this.props.t('99')}</button>&nbsp;
                                            <button onClick={this.postProduct} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>{this.props.t('100')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>


                    {/* Confirmation modal for bank payment */}
                    <div>
                        <Modal
                            isOpen={this.state.modalIsOpenbank}
                            onAfterOpen={this.afteropenModalforbank}
                            onRequestClose={this.closeModalforbank}
                            style={customStyles}
                            contentLabel="Example Modal"
                        >
                            <div style={{ width: "270px", height: "400px", overflow: "auto" }}>
                                <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModalforbank} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div style={{ padding: "1%" }}>
                                    <form>

                                        <legend style={{ width: "25%", color: "#008dc7", fontSize: "20px" }}>{this.props.t('39')}</legend>
                                        <div className="col-md-12" style={{ textAlign: "center" }}>
                                            {this.props.t('2')}
                                        </div>
                                        <div className="col-md-12"><br /></div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('66')}</b></i></span>
                                            </div>
                                            <div className="col-md-1">:</div>
                                            <div className="col-md-7">
                                                <span>{this.state.productDetails_single.title}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('67')}</b></i></span>
                                            </div>
                                            <div className="col-md-1">:</div>
                                            <div className="col-md-7">
                                                <span>{this.state.productDetails_single.category_main}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('68')}</b></i></span>
                                            </div>
                                            <div className="col-md-1">:</div>
                                            <div className="col-md-7">
                                                <span>{this.state.productDetails_single.category_sub}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('40')}</b></i></span>
                                            </div>
                                            <div className="col-md-1">:</div>
                                            <div className="col-md-7">
                                                {/* <span>{this.state.productDetails_single.long_desc}</span> */}
                                                <span>{this.state.product_description}....</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('180')}</b></i></span>
                                            </div>
                                            <div className="col-md-1">:</div>
                                            <div className="col-md-7">
                                                <span>{this.state.productDetails_single.price} {this.props.t('199')}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('97')}</b></i></span>
                                            </div>
                                            <div className="col-md-1">:</div>
                                            <div className="col-md-7">
                                                <span>{this.state.productDetails_single.delivery_format}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('30')}</b></i></span>
                                            </div>
                                            <div className="col-md-1">:</div>
                                            <div className="col-md-7">
                                                <span>{this.state.productDetails_single.expected_delivery_days}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('167')}</b></i></span>
                                            </div>
                                            <div className="col-md-1">:</div>
                                            <div className="col-md-7">
                                                <span>{this.state.seller_single.first_name}</span>
                                            </div>
                                        </div>


                                        <div><br /></div>
                                        <div>&nbsp;</div>
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModalforbank} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>{this.props.t('99')}</button>&nbsp;
                                        <button onClick={this.postProduct} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>{this.props.t('100')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>


                    {/* Instruction modal for bank payment */}
                    <div>
                        <Modal
                            isOpen={this.state.modalIsOpenbankinstructions}
                            onAfterOpen={this.afteropenModalforbankinstructions}
                            onRequestClose={this.closeModalforbankinstructions}
                            style={customStyles}
                            contentLabel="Example Modal"
                        >
                            <div style={{ width: "270px", height: "400px", overflow: "auto" }}>
                                <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModalforbankinstructions} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div style={{ padding: "1%" }}>
                                    <form>

                                        <legend style={{ width: "25%", color: "#008dc7", fontSize: "20px" }}>{this.props.t('33')}</legend>
                                        <div className="col-md-12"><br /></div>

                                        <div className="col-md-12 row">
                                            <div className="col-md-2"></div>
                                            <div className="col-md-8">
                                                <div>
                                                    * {this.props.t('0')}
                                                </div>
                                                <div>
                                                    * {this.props.t('10')}
                                                </div>
                                            </div>
                                            <div className="col-md-2"></div>
                                        </div>

                                        <div><br /></div>
                                        <div>&nbsp;</div>
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModalforbankinstructions} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%", width: "101px" }}>{this.props.t('65')}</button>&nbsp;
                                        <button onClick={this.instructionreceived} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%", width: "101px" }}>{this.props.t('96')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>


                    {/* Request payment with points */}
                    <div>
                        <Modal
                            isOpen={this.state.modalRequestopenpoints}
                            onAfterOpen={this.afteropenModalwithpointrequest}
                            onRequestClose={this.closeModalwithpointrequest}
                            style={customStyles}
                            contentLabel="Example Modal"
                        >
                            <div style={{ width: "270px", height: "400px", overflow: "auto" }}>
                                <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModalwithpointrequest} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div className="pages_contents" style={{ padding: "1%" }}>
                                    <form>

                                        <legend style={{ width: "100%", paddingLeft: '5%', fontSize: "20px" }}>{this.props.t('39')}</legend>
                                        <div className="col-md-12"><br /></div>
                                        {(() => {
                                            if (this.state.product_name !== '') {
                                                return (
                                                    <div className="col-md-12 row">
                                                        <div className="col-md-1"></div>
                                                        <div className="col-md-3">
                                                            <span><i><b>{this.props.t('108')}</b></i></span>
                                                        </div>
                                                        {/* <div className="col-md-1">:</div> */}
                                                        <div className="col-md-7">
                                                            <span>{this.state.product_name}</span>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        })()}
                                        <div className="col-md-12 pages_contents row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('108')}</b></i></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.request.title}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('110')}</b></i></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.response.content}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('183')}</b></i></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.response.estimated_price}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('111')}</b></i></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.props.location.state.estimated_deadline}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('167')}</b></i></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.seller_request.first_name}</span>
                                            </div>
                                        </div>

                                        <div><br /></div>
                                        <div>&nbsp;</div>
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModalwithpointrequest} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>{this.props.t('99')}</button>&nbsp;
                                        <button onClick={this.postRequestPurchase} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>{this.props.t('100')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>



                    {/* Request payment with bank account */}
                    <div>
                        <Modal
                            isOpen={this.state.modalRequestopenbank}
                            onAfterOpen={this.afteropenModalwithbankrequest}
                            onRequestClose={this.closeModalwithbankrequest}
                            style={customStyles}
                            contentLabel="Example Modal"
                        >
                            <div style={{ width: "270px", height: "400px", overflow: "auto" }}>
                                <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModalwithbankrequest} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div style={{ padding: "1%" }}>
                                    <form>

                                        <legend style={{ width: "25%", color: "#008dc7", fontSize: "20px" }}>{this.props.t('39')}</legend>
                                        <div className="col-md-12"><br /></div>
                                        <div className="col-md-12" style={{ textAlign: "center" }}>
                                            {this.props.t('2')}
                                        </div>
                                        <div className="col-md-12"><br /></div>
                                        {(() => {
                                            if (this.state.product_name !== '') {
                                                return (
                                                    <div className="col-md-12 row">
                                                        <div className="col-md-1"></div>
                                                        <div className="col-md-3">
                                                            <span><i><b>{this.props.t('108')}</b></i></span>
                                                        </div>
                                                        <div className="col-md-1">:</div>
                                                        <div className="col-md-7">
                                                            <span>{this.state.product_name}</span>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        })()}
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('108')}</b></i></span>
                                            </div>
                                            <div className="col-md-1">:</div>
                                            <div className="col-md-7">
                                                <span>{this.state.request.title}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('110')}</b></i></span>
                                            </div>
                                            <div className="col-md-1">:</div>
                                            <div className="col-md-7">
                                                <span>{this.state.response.content}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('183')}</b></i></span>
                                            </div>
                                            <div className="col-md-1">:</div>
                                            <div className="col-md-7">
                                                <span>{this.state.response.estimated_price}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('111')}</b></i></span>
                                            </div>
                                            <div className="col-md-1">:</div>
                                            <div className="col-md-7">
                                                <span>{this.props.location.state.estimated_deadline}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('167')}</b></i></span>
                                            </div>
                                            <div className="col-md-1">:</div>
                                            <div className="col-md-7">
                                                <span>{this.state.seller_request.first_name}</span>
                                            </div>
                                        </div>

                                        <div><br /></div>
                                        <div>&nbsp;</div>
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModalwithbankrequest} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>{this.props.t('99')}</button>&nbsp;
                                        <button onClick={this.postRequestPurchase} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>{this.props.t('100')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>



                    {/* Request payment with credit card */}
                    <div>
                        <Modal
                            isOpen={this.state.modalRequestopencredit}
                            onAfterOpen={this.afteropenModalwithbankrequest}
                            onRequestClose={this.closeModalwithcreditrequest}
                            style={customStyles}
                            contentLabel="Example Modal"
                        >
                            <div style={{ width: "270px", height: "400px", overflow: "auto" }}>
                                <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModalwithcreditrequest} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div style={{ padding: "1%" }}>
                                    <form>

                                        <legend style={{ width: "100%", paddingLeft: '5%', fontSize: "20px" }}>{this.props.t('39')}</legend>
                                        <div className="col-md-12"><br /></div>
                                        <div className="col-md-12"><br /></div>
                                        {(() => {
                                            if (this.state.product_name !== '') {
                                                return (
                                                    <div className="col-md-12 row">
                                                        <div className="col-md-1"></div>
                                                        <div className="col-md-3">
                                                            <span><i><b>{this.props.t('108')}</b></i></span>
                                                        </div>
                                                        {/* <div className="col-md-1">:</div> */}
                                                        <div className="col-md-7">
                                                            <span>{this.state.product_name}</span>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        })()}
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('108')}</b></i></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.request.title}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('110')}</b></i></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.response.content}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('183')}</b></i></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.response.estimated_price}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('111')}</b></i></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.props.location.state.estimated_deadline}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('167')}</b></i></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.seller_request.first_name}</span>
                                            </div>
                                        </div>

                                        <div><br /></div>

                                        <legend style={{ width: "25%", color: "#008dc7", fontSize: "20px" }}>{this.props.t('25')}</legend>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('64')}</b></i></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.creditcardnumber}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('95')}</b></i></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.validity}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('38')}</b></i></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.name}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-3">
                                                <span><i><b>{this.props.t('16')}</b></i></span>
                                            </div>
                                            {/* <div className="col-md-1">:</div> */}
                                            <div className="col-md-7">
                                                <span>{this.state.security}</span>
                                            </div>
                                        </div>

                                        <div><br /></div>
                                        <div>&nbsp;</div>
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModalwithcreditrequest} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>{this.props.t('99')}</button>&nbsp;
                                        <button onClick={this.postRequestPurchase} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>{this.props.t('100')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>


                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid main">
                        <div className="row mb-4">
                            <div className="col-md-2">
                            </div>
                            <div className="col-md-8">
                                <form onSubmit={this.handleSubmit.bind(this)}>
                                    <div className="mb-2">
                                        {this.props.t('12')}
                                    </div>
                                    <div className="top_back" style={{ fontSize: '13px' }}>
                                        <table style={{ width: "100%" }}>
                                            {this.state.productDetails.map(res =>
                                                <tbody>
                                                    <tr>
                                                        <td className="invoice" style={{ fontSize: '10px' }}>
                                                            {this.props.t('127')}ID
                                                            </td>
                                                        <td style={{ width: "70%", fontSize: "10px", textAlign: "center", border: "1px solid #eee", backgroundColor: "#dfdcda" }}>
                                                            {this.props.t('186')}
                                                            </td>
                                                        <td className="invoice" style={{ fontSize: '10px' }}>
                                                            {this.props.t('180')}
                                                            </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="input_name content_dertails" style={{ fontSize: '10px' }}>
                                                            {res.service_id}
                                                        </td>
                                                        <td className="input_name content_dertails text-left" style={{ fontSize: "10px" }} >
                                                            {renderHTML(res.title)}
                                                            {renderHTML(res.short_desc)}
                                                        </td>
                                                        <td className="input_name content_dertails" style={{ fontSize: '10px' }}>
                                                            {parseInt(res.price)}{this.props.t('199')}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="invoice" style={{ fontSize: '10px' }}>

                                                        </td>
                                                        <td style={{ width: "70%", fontSize: "12px", textAlign: "center", fontSize: '10px', border: "1px solid #eee", backgroundColor: "#dfdcda", textAlignLast: 'right' }}>
                                                            {this.props.t('188')}
                                                            </td>
                                                        <td className="input_name content_dertails" style={{ fontSize: '10px' }}>
                                                            {parseInt(res.price)}{this.props.t('199')}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            )}
                                        </table>
                                    </div>
                                    <div className="payment_methods mt-3">
                                        {this.props.t('50')} {this.state.extra_text}
                                    </div>
                                    {this.paymentMehod()}
                                    <div id="using_point" className="input_name bigger_pad" onSubmit={this.handleSubmit.bind(this)}>
                                        <button type="submit" className="check_button">{this.props.t('96')}</button>
                                    </div>
                                </form>

                                {/* card payment */}
                                <div id="using_card" className="input_name bigger_pad" style={{display: "none"}}>
                                    {/*action="https://payment.alij.ne.jp/service/credit"*/}
                                    <form onSubmit={this.handlePurchaseSubmit.bind(this)} method="POST" accept-charset="UTF-8">
                                        <input type="hidden" name="siteId" value={this.state.siteid} />
                                        <input type="hidden" name="sitePass" value={this.state.sitepass} />
                                        {/* <input type="hidden" name="amount" value={this.props.location.state.estimated_price} /> */}
                                        {/* <input type="hidden" name="amount" value={this.state.productDetails_single.price} /> */}
                                        <input type="hidden" name="amount" value={this.props.location.state.estimated_price > 0 ? this.props.location.state.estimated_price : this.state.productDetails_single.price} />
                                        <input type="hidden" name="itemId" value={this.state.productId} />
                                        <input type="hidden" name="CustomerId" value={this.state.buyer_id + this.state.special} />
                                        <input type="hidden" name="specialValue" value={this.state.special} />
                                        <input type="hidden" name="service_id" value={this.state.serviceId} />
                                        <input type="hidden" name="affiliator_id" value={this.state.aff_Id} />
                                        <input type="hidden" name="request_id" value={this.props.location.state.request_id} />
                                        <button type="submit" className="check_button">{this.props.t('96')}</button>
                                    </form>
                                </div>

                                {/* bank payment */}
                                <div id="using_bank" className="input_name bigger_pad" style={{display: "none"}}>
                                    {/*action="https://payment.alij.ne.jp/service/credit"*/}
                                    <form onSubmit={this.handlePurchaseSubmit.bind(this)} method="POST" accept-charset="UTF-8">
                                        <input type="hidden" name="siteId" value={'20236603'} />
                                        <input type="hidden" name="sitePass" value={'6603wuro'} />
                                        {/* <input type="hidden" name="amount" value={this.props.location.state.estimated_price} /> */}
                                        {/* <input type="hidden" name="amount" value={this.state.productDetails_single.price} /> */}
                                        <input type="hidden" name="amount" value={this.props.location.state.estimated_price > 0 ? this.props.location.state.estimated_price : this.state.productDetails_single.price} />
                                        <input type="hidden" name="itemId" value={this.state.productId} />
                                        <input type="hidden" name="CustomerId" value={this.state.buyer_id} />
                                        <input type="hidden" name="service_id" value={this.state.serviceId} />
                                        <input type="hidden" name="affiliator_id" value={this.state.aff_Id} />
                                        <input type="hidden" name="request_id" value={this.props.location.state.request_id} />
                                        <button type="submit" className="check_button">{this.props.t('96')}</button>
                                    </form>
                                </div>
                            </div>
                            <div className="col-md-2">

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        } else if (isDesktop) {
            return (
                <div className="wrapper">
                    <Header />

                    {/* Confirmation modal */}

                    {/* Credit card input modal */}
                    <div>
                        <Modal
                            isOpen={this.state.modalIsOpenCredit}
                            onAfterOpen={this.afterOpenModalforcreditcard}
                            onRequestClose={this.closeModalforcreditcard}
                            style={customStyles}
                            // overlayClassName="Overlay"
                            contentLabel="Example Modal"
                        >

                            <div style={{ width: "850px", height: "515px", overflow: "auto" }}>
                                <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModalforcreditcard} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div style={{ padding: "1%" }}>
                                    <form>
                                        <fieldset style={{ border: "1px solid #008dc7", paddingLeft: "4%", paddingRight: "4%", paddingBottom: "4%" }}>
                                            <legend style={{ width: "0%", color: "#008dc7", fontSize: "20px" }}></legend>
                                            <div><br /></div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-4" style={{ backgroundColor: "#f5f3f3", paddingTop: "2%", textAlign: "center" }}>
                                                    <span>{this.props.t('38')}</span>
                                                </div>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-7">
                                                    <div>
                                                        <input
                                                            style={{ padding: "2%", border: "1px solid #d8e6e8" }}
                                                            type="text"
                                                            className="catagory_select"
                                                            id="name"
                                                            value={this.state.name}
                                                            onChange={this.updateValue.bind(this, 'name')}
                                                        />
                                                    </div>
                                                    <div>
                                                        <span style={{ color: "grey", fontSize: "12px" }}>※{this.props.t('6')}</span>
                                                    </div>

                                                </div>
                                            </div>
                                            <div><br /></div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-4" style={{ backgroundColor: "#f5f3f3", paddingTop: "2%", textAlign: "center" }}>
                                                    <span>{this.props.t('64')}</span>
                                                </div>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-7">
                                                    <div>
                                                        <input
                                                            style={{ padding: "2%", border: "1px solid #d8e6e8" }}
                                                            type="number"
                                                            className="catagory_select"
                                                            id="creditcardnumber"
                                                            value={this.state.creditcardnumber}
                                                            onChange={this.updateValue.bind(this, 'creditcardnumber')}
                                                        />
                                                    </div>
                                                    <div>
                                                        <span style={{ color: "grey", fontSize: "12px" }}>{this.props.t('179')}1234567890123456</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div><br /></div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-4" style={{ backgroundColor: "#f5f3f3", paddingTop: "2%", textAlign: "center" }}>
                                                    <span>{this.props.t('95')}</span>
                                                </div>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-7">
                                                    <div>
                                                        <input
                                                            style={{ padding: "1%", border: "1px solid #d8e6e8" }}
                                                            type="date"
                                                            className="validity"
                                                            id="title"
                                                            value={this.state.validity}
                                                            onChange={this.updateValue.bind(this, 'validity')}
                                                        />
                                                    </div>
                                                    <div>
                                                        <span style={{ color: "grey", fontSize: "12px" }}>※{this.props.t('7')}</span>
                                                    </div>

                                                </div>
                                            </div>
                                            <div><br /></div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-4" style={{ backgroundColor: "#f5f3f3", paddingTop: "1%", textAlign: "center" }}>
                                                    <span>{this.props.t('16')}</span>
                                                </div>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-7">
                                                    <input
                                                        style={{ padding: "2%", border: "1px solid #d8e6e8" }}
                                                        type="number"
                                                        className="catagory_select"
                                                        id="security"
                                                        value={this.state.security}
                                                        onChange={this.updateValue.bind(this, 'security')}
                                                    />
                                                </div>
                                            </div>
                                        </fieldset>


                                        <div>&nbsp;</div>
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModalforcreditcard} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>{this.props.t('65')}</button>&nbsp;
                                        <button onClick={this.creditsubmit} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>{this.props.t('96')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>

                    {/* ProductConfirmation modal */}
                    <div>
                        <Modal
                            isOpen={this.state.modalIsOpen}
                            onAfterOpen={this.afterOpenModal}
                            onRequestClose={this.closeModal}
                            style={customStyles}
                            contentLabel="Example Modal"
                        >
                            <div style={{ width: "850px", height: "515px", overflow: "auto" }}>
                                <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModal} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div style={{ padding: "1%" }}>
                                    <form>
                                        <fieldset style={{ border: "1px solid #008dc7", paddingLeft: "4%", paddingRight: "4%", paddingBottom: "4%" }}>
                                            <legend style={{ width: "25%", color: "#008dc7", fontSize: "20px" }}>{this.props.t('39')}</legend>
                                            <div className="col-md-12"><br /></div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('66')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.productDetails_single.title}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('67')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.productDetails_single.category_main}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('68')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.productDetails_single.category_sub}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('40')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    {/* <span>{this.state.productDetails_single.long_desc}</span> */}
                                                    <span>{this.state.product_description}....</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('180')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.productDetails_single.price} {this.props.t('199')}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('97')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.productDetails_single.delivery_format}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('30')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.productDetails_single.expected_delivery_days}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('167')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.seller_single.first_name}</span>
                                                </div>
                                            </div>

                                        </fieldset>
                                        <div><br /></div>
                                        <fieldset style={{ border: "1px solid #008dc7", paddingLeft: "4%", paddingRight: "4%", paddingBottom: "4%" }}>
                                            <legend style={{ width: "25%", color: "#008dc7", fontSize: "20px" }}>{this.props.t('25')}</legend>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('64')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.creditcardnumber}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('95')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.validity}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('38')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.name}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('16')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.security}</span>
                                                </div>
                                            </div>
                                        </fieldset>


                                        <div>&nbsp;</div>
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModal} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>{this.props.t('99')}</button>&nbsp;
                                        <button onClick={this.postProduct} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>{this.props.t('100')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>
                    {/* confirmation modal ends */}

                    {/* Confirmation modal for payment with point */}
                    <div>
                        <Modal
                            isOpen={this.state.modalIsOpenwithpoint}
                            onAfterOpen={this.afteropenModalwithpoint}
                            onRequestClose={this.closeModalwithpoint}
                            style={customStyles}
                            contentLabel="Example Modal"
                        >
                            <div style={{ width: "850px", height: "515px", overflow: "auto" }}>
                                <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModalwithpoint} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div style={{ padding: "1%" }}>
                                    <form>
                                        <fieldset style={{ border: "1px solid #008dc7", paddingLeft: "4%", paddingRight: "4%", paddingBottom: "4%" }}>
                                            <legend style={{ width: "25%", color: "#008dc7", fontSize: "20px" }}>{this.props.t('39')}</legend>
                                            <div className="col-md-12"><br /></div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('66')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.productDetails_single.title}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('67')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.productDetails_single.category_main}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('68')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.productDetails_single.category_sub}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('40')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    {/* <span>{this.state.productDetails_single.long_desc}</span> */}
                                                    <span>{this.state.product_description}....</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('180')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.productDetails_single.price} {this.props.t('199')}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('97')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.productDetails_single.delivery_format}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('30')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.productDetails_single.expected_delivery_days}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('167')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.seller_single.first_name}</span>
                                                </div>
                                            </div>

                                        </fieldset>
                                        <div><br /></div>
                                        <div>&nbsp;</div>
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModalwithpoint} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>{this.props.t('99')}</button>&nbsp;
                                        <button onClick={this.postProduct} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>{this.props.t('100')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>


                    {/* Confirmation modal for bank payment */}
                    <div>
                        <Modal
                            isOpen={this.state.modalIsOpenbank}
                            onAfterOpen={this.afteropenModalforbank}
                            onRequestClose={this.closeModalforbank}
                            style={customStyles}
                            contentLabel="Example Modal"
                        >
                            <div style={{ width: "850px", height: "515px", overflow: "auto" }}>
                                <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModalforbank} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div style={{ padding: "1%" }}>
                                    <form>
                                        <fieldset style={{ border: "1px solid #008dc7", paddingLeft: "4%", paddingRight: "4%", paddingBottom: "4%" }}>
                                            <legend style={{ width: "25%", color: "#008dc7", fontSize: "20px" }}>{this.props.t('39')}</legend>
                                            <div className="col-md-12" style={{ textAlign: "center" }}>
                                                {this.props.t('2')}
                                        </div>
                                            <div className="col-md-12"><br /></div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('66')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.productDetails_single.title}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('67')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.productDetails_single.category_main}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('68')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.productDetails_single.category_sub}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('40')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    {/* <span>{this.state.productDetails_single.long_desc}</span> */}
                                                    <span>{this.state.product_description}....</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('180')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.productDetails_single.price} {this.props.t('199')}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('97')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.productDetails_single.delivery_format}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('30')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.productDetails_single.expected_delivery_days}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('167')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.seller_single.first_name}</span>
                                                </div>
                                            </div>

                                        </fieldset>
                                        <div><br /></div>
                                        <div>&nbsp;</div>
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModalforbank} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>{this.props.t('99')}</button>&nbsp;
                                        <button onClick={this.postProduct} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>{this.props.t('100')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>


                    {/* Instruction modal for bank payment */}
                    <div>
                        <Modal
                            isOpen={this.state.modalIsOpenbankinstructions}
                            onAfterOpen={this.afteropenModalforbankinstructions}
                            onRequestClose={this.closeModalforbankinstructions}
                            style={customStyles}
                            contentLabel="Example Modal"
                        >
                            <div style={{ width: "850px", height: "515px", overflow: "auto" }}>
                                <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModalforbankinstructions} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div style={{ padding: "1%" }}>
                                    <form>
                                        <fieldset style={{ border: "1px solid #008dc7", paddingLeft: "4%", paddingRight: "4%", paddingBottom: "4%" }}>
                                            <legend style={{ width: "25%", color: "#008dc7", fontSize: "20px" }}>{this.props.t('33')}</legend>
                                            <div className="col-md-12"><br /></div>

                                            <div className="col-md-12 row">
                                                <div className="col-md-2"></div>
                                                <div className="col-md-8">
                                                    <div>
                                                        * {this.props.t('0')}
                                                </div>
                                                    <div>
                                                        * {this.props.t('10')}
                                                </div>
                                                </div>
                                                <div className="col-md-2"></div>
                                            </div>
                                        </fieldset>
                                        <div><br /></div>
                                        <div>&nbsp;</div>
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModalforbankinstructions} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%", width: "101px" }}>{this.props.t('65')}</button>&nbsp;
                                        <button onClick={this.instructionreceived} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%", width: "101px" }}>{this.props.t('96')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>


                    {/* Request payment with points */}
                    <div>
                        <Modal
                            isOpen={this.state.modalRequestopenpoints}
                            onAfterOpen={this.afteropenModalwithpointrequest}
                            onRequestClose={this.closeModalwithpointrequest}
                            style={customStyles}
                            contentLabel="Example Modal"
                        >
                            <div style={{ width: "850px", height: "515px", overflow: "auto" }}>
                                <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModalwithpointrequest} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div style={{ padding: "1%" }}>
                                    <form>
                                        <fieldset style={{ border: "1px solid #008dc7", paddingLeft: "4%", paddingRight: "4%", paddingBottom: "4%" }}>
                                            <legend style={{ width: "25%", color: "#008dc7", fontSize: "20px" }}>{this.props.t('39')}</legend>
                                            <div className="col-md-12"><br /></div>
                                            {(() => {
                                                if (this.state.product_name !== '') {
                                                    return (
                                                        <div className="col-md-12 row">
                                                            <div className="col-md-1"></div>
                                                            <div className="col-md-3">
                                                                <span><i><b>{this.props.t('108')}</b></i></span>
                                                            </div>
                                                            <div className="col-md-1">:</div>
                                                            <div className="col-md-7">
                                                                <span>{this.state.product_name}</span>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            })()}
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('108')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.request.title}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('110')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.response.content}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('183')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.response.estimated_price}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('111')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.props.location.state.estimated_deadline}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('167')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.seller_request.first_name}</span>
                                                </div>
                                            </div>
                                        </fieldset>
                                        <div><br /></div>
                                        <div>&nbsp;</div>
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModalwithpointrequest} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>{this.props.t('99')}</button>&nbsp;
                                        <button onClick={this.postRequestPurchase} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>{this.props.t('100')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>



                    {/* Request payment with bank account */}
                    <div>
                        <Modal
                            isOpen={this.state.modalRequestopenbank}
                            onAfterOpen={this.afteropenModalwithbankrequest}
                            onRequestClose={this.closeModalwithbankrequest}
                            style={customStyles}
                            contentLabel="Example Modal"
                        >
                            <div style={{ width: "850px", height: "515px", overflow: "auto" }}>
                                <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModalwithbankrequest} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div style={{ padding: "1%" }}>
                                    <form>
                                        <fieldset style={{ border: "1px solid #008dc7", paddingLeft: "4%", paddingRight: "4%", paddingBottom: "4%" }}>
                                            <legend style={{ width: "25%", color: "#008dc7", fontSize: "20px" }}>{this.props.t('39')}</legend>
                                            <div className="col-md-12"><br /></div>
                                            <div className="col-md-12" style={{ textAlign: "center" }}>
                                                {this.props.t('2')}
                                        </div>
                                            <div className="col-md-12"><br /></div>
                                            {(() => {
                                                if (this.state.product_name !== '') {
                                                    return (
                                                        <div className="col-md-12 row">
                                                            <div className="col-md-1"></div>
                                                            <div className="col-md-3">
                                                                <span><i><b>{this.props.t('108')}</b></i></span>
                                                            </div>
                                                            <div className="col-md-1">:</div>
                                                            <div className="col-md-7">
                                                                <span>{this.state.product_name}</span>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            })()}
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('108')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.request.title}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('110')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.response.content}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('183')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.response.estimated_price}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('111')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.props.location.state.estimated_deadline}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('167')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.seller_request.first_name}</span>
                                                </div>
                                            </div>
                                        </fieldset>
                                        <div><br /></div>
                                        <div>&nbsp;</div>
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModalwithbankrequest} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>{this.props.t('99')}</button>&nbsp;
                                        <button onClick={this.postRequestPurchase} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>{this.props.t('100')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>



                    {/* Request payment with credit card */}
                    <div>
                        <Modal
                            isOpen={this.state.modalRequestopencredit}
                            onAfterOpen={this.afteropenModalwithbankrequest}
                            onRequestClose={this.closeModalwithcreditrequest}
                            style={customStyles}
                            contentLabel="Example Modal"
                        >
                            <div style={{ width: "850px", height: "515px", overflow: "auto" }}>
                                <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModalwithcreditrequest} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div style={{ padding: "1%" }}>
                                    <form>
                                        <fieldset style={{ border: "1px solid #008dc7", paddingLeft: "4%", paddingRight: "4%", paddingBottom: "4%" }}>
                                            <legend style={{ width: "25%", color: "#008dc7", fontSize: "20px" }}>{this.props.t('39')}</legend>
                                            <div className="col-md-12"><br /></div>
                                            <div className="col-md-12"><br /></div>
                                            {(() => {
                                                if (this.state.product_name !== '') {
                                                    return (
                                                        <div className="col-md-12 row">
                                                            <div className="col-md-1"></div>
                                                            <div className="col-md-3">
                                                                <span><i><b>{this.props.t('108')}</b></i></span>
                                                            </div>
                                                            <div className="col-md-1">:</div>
                                                            <div className="col-md-7">
                                                                <span>{this.state.product_name}</span>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            })()}
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('108')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.request.title}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('110')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.response.content}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('183')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.response.estimated_price}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('111')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.props.location.state.estimated_deadline}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('167')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.seller_request.first_name}</span>
                                                </div>
                                            </div>
                                        </fieldset>
                                        <div><br /></div>
                                        <fieldset style={{ border: "1px solid #008dc7", paddingLeft: "4%", paddingRight: "4%", paddingBottom: "4%" }}>
                                            <legend style={{ width: "25%", color: "#008dc7", fontSize: "20px" }}>{this.props.t('25')}</legend>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('64')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.creditcardnumber}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('95')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.validity}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('38')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.name}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('16')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.security}</span>
                                                </div>
                                            </div>
                                        </fieldset>
                                        <div><br /></div>
                                        <div>&nbsp;</div>
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModalwithcreditrequest} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>{this.props.t('99')}</button>&nbsp;
                                        <button onClick={this.postRequestPurchase} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>{this.props.t('100')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>


                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid main">
                        <div className="container" style={{ minHeight: "600px" }}>
                            <div className="col-md-12">
                                <div className="row mb-4">
                                    <div className="col-md-2">
                                    </div>
                                    <div className="col-md-8">
                                        <form onSubmit={this.handleSubmit.bind(this)}>
                                            <div className="large_fonts">
                                                {this.props.t('12')}
                                        </div>
                                            <div className="top_back">
                                                <table style={{ width: "100%" }}>
                                                    {this.state.productDetails.map(res =>
                                                        <tbody>
                                                            <tr>
                                                                <td className="invoice">
                                                                    {this.props.t('127')}ID
                                                            </td>
                                                                <td style={{ width: "70%", fontSize: "12px", textAlign: "center", border: "1px solid #eee", backgroundColor: "#dfdcda" }}>
                                                                    {this.props.t('186')}
                                                            </td>
                                                                <td className="invoice">
                                                                    {this.props.t('180')}
                                                            </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="input_name content_dertails">
                                                                    {res.service_id}
                                                                </td>
                                                                <td className="input_name content_dertails text-left">
                                                                    {renderHTML(res.title)}
                                                                    {renderHTML(res.short_desc)}
                                                                </td>
                                                                <td className="input_name content_dertails">
                                                                    ¥ {parseInt(res.price)}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="invoice">

                                                                </td>
                                                                <td style={{ width: "70%", fontSize: "12px", textAlign: "center", border: "1px solid #eee", backgroundColor: "#dfdcda", textAlignLast: 'right' }}>
                                                                    {this.props.t('188')}
                                                            </td>
                                                                <td className="input_name content_dertails">
                                                                    ¥ {parseInt(res.price)}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    )}
                                                </table>
                                            </div>
                                            <div className="payment_methods mt-3">
                                                {this.props.t('50')} {this.state.extra_text}
                                            </div>
                                            {this.paymentMehod()}
                                            <div id="using_point" className="input_name bigger_pad" onSubmit={this.handleSubmit.bind(this)}>
                                                <button type="submit" className="check_button">{this.props.t('96')}</button>
                                            </div>
                                        </form>

                                        {/* card payment */}
                                        <div id="using_card" className="input_name bigger_pad" style={{display: "none"}}>
                                            {/* <form action="https://payment.alij.ne.jp/service/credit" method="POST" accept-charset="UTF-8"> */}
                                            {/*<form action="https://sharework-admin.bitpeboot.com/backend/purchase" method="POST" accept-charset="UTF-8">*/}
                                            {/*action={`${Common.api}purchase`}*/}
                                            <form onSubmit={this.handlePurchaseSubmit.bind(this)} method="POST" accept-charset="UTF-8">
                                                <input type="hidden" name="siteId" value={this.state.siteid} />
                                                <input type="hidden" name="sitePass" value={this.state.sitepass} />
                                                {/* <input type="hidden" name="amount" value={this.props.location.state.estimated_price} /> */}
                                                {/* <input type="hidden" name="amount" value={this.state.productDetails_single.price} /> */}
                                                <input type="hidden" name="amount" value={this.props.location.state.estimated_price > 0 ? this.props.location.state.estimated_price : this.state.productDetails_single.price} />
                                                <input type="hidden" name="itemId" value={this.state.productId} />
                                                <input type="hidden" name="CustomerId" value={this.state.buyer_id + this.state.special} />
                                                <input type="hidden" name="specialValue" value={this.state.special} />
                                                <input type="hidden" name="service_id" value={this.state.serviceId} />
                                                <input type="hidden" name="affiliator_id" value={this.state.aff_Id} />
                                                <input type="hidden" name="request_id" value={this.props.location.state.request_id} />
                                                <button type="submit" className="check_button">{this.props.t('96')}</button>
                                            </form>
                                        </div>

                                        {/* bank payment */}
                                        <div id="using_bank" className="input_name bigger_pad" style={{display: "none"}}>
                                            {/*action="https://payment.alij.ne.jp/service/credit"*/}
                                            <form onSubmit={this.handlePurchaseSubmit.bind(this)} method="POST" accept-charset="UTF-8">
                                                <input type="hidden" name="siteId" value={'20236603'} />
                                                <input type="hidden" name="sitePass" value={'6603wuro'} />
                                                {/* <input type="hidden" name="amount" value={this.props.location.state.estimated_price} /> */}
                                                {/* <input type="hidden" name="amount" value={this.state.productDetails_single.price} /> */}
                                                <input type="hidden" name="amount" value={this.props.location.state.estimated_price > 0 ? this.props.location.state.estimated_price : this.state.productDetails_single.price} />
                                                <input type="hidden" name="itemId" value={this.state.productId} />
                                                <input type="hidden" name="CustomerId" value={this.state.buyer_id} />
                                                <input type="hidden" name="service_id" value={this.state.serviceId} />
                                                <input type="hidden" name="affiliator_id" value={this.state.aff_Id} />
                                                <input type="hidden" name="request_id" value={this.props.location.state.request_id} />
                                                <button type="submit" className="check_button">{this.props.t('96')}</button>
                                            </form>
                                        </div>
                                    </div>
                                    <div className="col-md-2">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="input_name bigger_pad">

                    </div>
                    <Footer />
                </div>
            )
        }
        } else {
            return (
                <div className="container-fluid">
                    <div className="container">
                        <div className="" style={{ height: '380px' }}></div>
                        <div className="text-center mt-3">
                            <Spinner color="primary" size="150" />
                        </div>
                    </div>
                </div>
            )
        }
    }
}
const mapStateToProps = (state) => ({
    paymentMethod: state.paymentMethod,
    errors: state.errors,
});

Purchase = connect(mapStateToProps, { paymentMethod })(withRouter(Purchase));
export { Purchase }
Purchase = withRouter(Purchase)


 Purchase = withTranslation('src_Components_Puarchase_Purchase')(Purchase);
